import React, { FunctionComponent } from 'react';
import styles from './HeroImageTop.module.scss';
import SwiperCore, { Navigation, Pagination, A11y } from 'swiper';
import { Block, BlockContent, Image } from 'components/elements';
import { Swiper, SwiperSlide } from 'swiper/react';
import { WPAcfHeroImageTop } from 'types/acf/hero';
import cx from 'clsx';
import { OnMobileOnly, OnTabletAndDesktopOnly } from 'utils';
import { useIntl } from 'react-intl';
import messages from 'messages/base-pl';

SwiperCore.use([Navigation, Pagination, A11y]);
interface OwnProps {
  whiteImages?: boolean;
  data: WPAcfHeroImageTop | null;
}

export type HeroImageTopLogosProps = JSX.IntrinsicElements['div'] & OwnProps;

const HeroImageTopLogos: FunctionComponent<HeroImageTopLogosProps> = props => {
  const { data } = props;
  const { formatMessage } = useIntl();

  if (!data || !data.logos) {
    return null;
  }

  const { logos = [] } = data;

  const a11y = {
    prevSlideMessage: formatMessage(messages.prev_slide),
    nextSlideMessage: formatMessage(messages.next_slide),
    paginationBulletMessage: formatMessage(messages.slide_message),
  };

  const renderMobileSlider = (numberOfChunks: number) => {
    const [list, chunkSize] = [[...logos], numberOfChunks];
    const chunks = [...Array(Math.ceil(list.length / chunkSize))].map(_ => list.splice(0, chunkSize));
    const hasSlider = logos.length > numberOfChunks;

    const sliderClassNames = cx({
      [styles.slider]: true,
      [styles.simple]: !hasSlider,
    });

    return (
      <div className={sliderClassNames}>
        <div className={styles.block}>
          <Swiper a11y={a11y} loop={true} navigation pagination={{ clickable: true }}>
            {chunks.map((chunk, index) => (
              <SwiperSlide key={`white-logos-desktop-${index}`}>
                <div className={styles.logos}>
                  {chunk
                    .filter(logo => logo)
                    .map((logo, logoIndex) => (
                      <div className={styles.logo} key={`white-logos-desktop-${index}-${logoIndex}`}>
                        {/* TODO: Responsive check */}
                        <Image height={1} width={2} sizes="(max-width: 767px) 50vw, (min-width: 768px) 10vw" className={styles.logoImage} acfConfig={logo} />
                      </div>
                    ))}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    );
  };

  const renderDesktopSlider = (numberOfSlides: number) => {
    const hasSlider = logos.length > numberOfSlides;

    const sliderClassNames = cx({
      [styles.slider]: true,
      [styles.simple]: !hasSlider,
    });

    return (
      <div className={sliderClassNames}>
        <div className={styles.block}>
          <Swiper a11y={a11y} loop={true} slidesPerView={numberOfSlides} navigation pagination={{ clickable: true }}>
            <div className={styles.logos}>
              {logos
                .filter(logo => logo)
                .map((logo, logoIndex) => (
                  <SwiperSlide key={`white-logos-desktop-${logoIndex}`}>
                    <div className={styles.logo}>
                      {/* TODO: Responsive check */}
                      <Image height={1} width={2} sizes="(max-width: 767px) 50vw, (min-width: 768px) 10vw" className={styles.logoImage} acfConfig={logo} />
                    </div>
                  </SwiperSlide>
                ))}
            </div>
          </Swiper>
        </div>
      </div>
    );
  };

  return (
    <Block id="hero-image-top-logos" theme="white" width="container" data-module="hero-image-top-logos">
      <BlockContent>
        <OnMobileOnly>{renderMobileSlider(5)}</OnMobileOnly>
        <OnTabletAndDesktopOnly>{renderDesktopSlider(5)}</OnTabletAndDesktopOnly>
      </BlockContent>
    </Block>
  );
};

export default HeroImageTopLogos;
